import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import PropTypes from "prop-types";
import React from "react";

import { fileType } from "../../../common/AppConstant";
import { addByteUnit } from "../../../common/AppUtil";
import useStyles from "../useStyles";

/**
 * データ登録アクションテーブルコンポーネント.
 *
 * @param {array} fileInfos 選択済みファイル情報一覧
 * @param {function} onCancel 選択済みファイルの解除ボタン押下時の処理
 * @return {object} コンポーネント
 */
function RegisterActionTable(props) {
  // 引数
  const {
    // 選択済みファイル情報一覧
    fileInfos,
    // 選択ファイルの解除ボタン押下時の処理
    onCancel,
  } = props;

  // スタイル
  const styles = useStyles();

  return (
    <TableContainer className={styles.tableContainerSmall}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              className={`${styles.tableHeader} ${styles.fileNameTableCellSmall}`}
            >
              ファイル名
            </TableCell>
            <TableCell
              className={`${styles.tableHeader} ${styles.fileSizeTableCellSmall}`}
            >
              サイズ
            </TableCell>
            <TableCell className={styles.iconTableCell} />
          </TableRow>
        </TableHead>
        <TableBody>
          {!fileInfos || !fileInfos.length ? (
            <TableRow>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
              <TableCell />
            </TableRow>
          ) : (
            fileInfos.map((fileInfo) => (
              <TableRow
                key={`FileActionTable_${
                  fileInfo.fileName ? fileInfo.fileName : fileInfo.name
                }`}
              >
                <TableCell>
                  <div className={styles.wordBreak}>
                    {fileInfo.fileName || fileInfo.name}
                  </div>
                </TableCell>
                <TableCell>
                  {addByteUnit(
                    fileType.file,
                    fileInfo.fileSize || fileInfo.size
                  )}
                </TableCell>
                <TableCell className={styles.iconTableCell}>
                  <IconButton
                    className={styles.canceliconButton}
                    color="inherit"
                    onClick={() => onCancel(fileInfo)}
                  >
                    <Cancel fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

RegisterActionTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fileInfos: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default RegisterActionTable;
